// slices/registerSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { agent } from '../../../utils/agent';
import * as API from '../../../utils/apiPath';

export const fetchSettings = createAsyncThunk('register/fetchSettings', async (_, { rejectWithValue }) => {
  try {
    const res = await agent.get(API.SETTING);
    return res.data.data;
  } catch (err) {
    return rejectWithValue(err.message);
  }
});

export const fetchProgrammes = createAsyncThunk('register/fetchProgrammes', async (_, { rejectWithValue }) => {
  try {
    const res = await agent.get(API.LOAD_PROGRAMMES + "/all");
    return res.data.data;
  } catch (err) {
    return rejectWithValue(err.message);
  }
});

export const fetchExperience = createAsyncThunk('register/fetchExperience', async (roleId, { rejectWithValue }) => {
  try {
    const res = await agent.get(API.EXPERIENCE);
    return res.data.data;
  } catch (err) {
    return rejectWithValue(err.message);
  }
});

const updateProfileStep1Slice = createSlice({
  name: 'updateProfileStep1',
  initialState: {
    setting: null,
    programmes: [],
    userExperience: [],
    loading: false,
    submitting: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => { state.loading = true; })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.setting = action.payload;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchProgrammes.fulfilled, (state, action) => {
        state.programmes = action.payload;
      })

      .addCase(fetchExperience.fulfilled, (state, action) => {
        state.userExperience = action.payload;
      });
  },
});

export default updateProfileStep1Slice.reducer;